<template>
  <div data-id-e2e="btnDownloadRenderer">
    <v-row v-if="isExtractGenerationJobRunning" class="generating-row">
      <v-tooltip location="bottom">
        <template #activator="{ props: tooltipActivatorProps }">
          <img
            v-bind="{ ...tooltipActivatorProps }"
            class="spinner-icon"
            src="@/assets/spinner.gif"
          />
        </template>
        <span class="generating-text">{{ $t('actions.generating') }}</span>
      </v-tooltip>
    </v-row>
    <BaseDownloadLink
      v-else
      :filename="extract.filenameOnDownload"
      :url="buildLink(extract.blobId)"
      :disabled="isDisabled"
    >
      <v-tooltip location="bottom">
        <template #activator="{ props: tooltipActivatorProps }">
          <v-btn
            data-id-e2e="btnDownloadExtracts"
            v-bind="{ ...tooltipActivatorProps }"
            icon
            variant="text"
            :disabled="isDisabled"
          >
            <v-icon size="23">mdi-tray-arrow-down</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('actions.download') }}</span>
      </v-tooltip>
    </BaseDownloadLink>
  </div>
</template>

<script>
import { get, size } from 'lodash';
import { mapState } from 'pinia';
import jobapi from '@enums/jobapi';
import { useCompoundExtractStore } from '@/stores/compound-extract';
import { useContextStore } from '@/stores/context';
import { usePermission } from '@/composables/use-permission';

const { jobStatuses } = jobapi;

export default {
  setup() {
    const { canEditCompoundExtracts } = usePermission();

    return { canEditCompoundExtracts };
  },

  data() {
    return {};
  },

  computed: {
    ...mapState(useCompoundExtractStore, ['getExtractById']),
    ...mapState(useContextStore, ['getCurrentTenant']),

    extractId() {
      return get(this.params, 'extractId');
    },

    extractTypes() {
      return get(this.params, 'extractTypes', []);
    },

    extract() {
      return this.getExtractById(this.extractId) || {};
    },

    isDisabled() {
      return !this.canEditCompoundExtracts || !size(this.extract.blobId);
    },

    extractGenerationJobStatus() {
      // if extract doesn't have any job status, set 'failed' by default
      return get(this.extract, 'jobs.compoundExtract.status', jobStatuses.failed);
    },

    isExtractGenerationJobRunning() {
      return (
        this.extractGenerationJobStatus &&
        ![jobStatuses.finished, jobStatuses.failed].includes(this.extractGenerationJobStatus)
      );
    },
  },

  methods: {
    buildLink(blobId) {
      const baseUrl = `/api/file/by-blob/${blobId}`;
      return this.getCurrentTenant ? `${baseUrl}?tenant=${this.getCurrentTenant}` : baseUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

a {
  text-decoration: none;
}

:deep(.download-extracts__button) {
  height: 29px !important;
  padding: 0 12px !important;

  > span {
    font-size: 1.4rem;
  }
}

.generating-row {
  padding-top: 7px;
  margin: -8px;

  .generating-text {
    margin: 0px 4px 0px 8px;
    font-size: 14px;
  }

  .spinner-icon {
    height: 18px;
    width: 18px;
    align-self: center;
  }
}
</style>
